<script>
import debounce from "lodash/debounce";

export default {
  props: ['term'],

  data () {
    return {
      results: [],
    }
  },

  methods: {
    goTo(result) {
      window.location.href = result.link
    },

    search: debounce(function (term) {
      axios.get(this.link, {params: {term}})
        .then(({data: {data: response}}) => {this.results = response})
    }, 300, {maxWait: 500})
  },

  watch: {
    term (term) {
      this.search(term)
    }
  }
}
</script>
